/**
 * Intro Blocks
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="intro-blocks"></div>
 */
import 'slick-carousel';
$(function () {
  $('[data-component="intro-blocks"]').slick({
    rows: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    variableWidth: true,
    dots: true,
    responsive: [{
      breakpoint: 991,
      settings: 'unslick'
    }]
  });
  $(window).on('resize', function () {
    $('[data-component="intro-blocks"]').slick('resize');
  });
  $('.intro-blocks__slide').hover(function () {
    $('.intro-blocks__slide').removeClass('is-hover');
    $(this).addClass('is-hover');
  });
});